import { Navigate } from "react-router-dom";
import { useAuth } from "../api/authContext";

export default function ProtectedRoute({ children }) {
    const { isAuthenticated, loading } = useAuth();

    if (loading) return <p>Chargement...</p>;

    return isAuthenticated ? children : <Navigate to="/login" replace />;
}
